import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Grid, Statistic, Tag, Spin, Space, Typography } from '@arco-design/web-react';
import {
  IconArrowRise,
  IconArrowFall,
  IconThunderbolt,
  IconUserGroup,
  IconSwap,
  IconExclamationCircle,
} from '@arco-design/web-react/icon';

const { Row, Col } = Grid;

const KpiCards = ({ kpis, loading }) => {
  const { t } = useTranslation('finance');

  if (loading) {
    return (
      <div style={{ minHeight: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spin size={40} />
      </div>
    );
  }

  if (!kpis) return null;

  const cards = [
    {
      title: t('kpis.mrr'),
      value: Number(kpis.mrr_usd || 0),
      prefix: '$',
      precision: 2,
      icon: <IconArrowRise style={{ color: '#00b42a' }} />,
      color: '#e8ffea',
    },
    {
      title: t('kpis.collectionRate'),
      value: Number(kpis.collection_rate || 0),
      suffix: '%',
      precision: 1,
      icon: <IconThunderbolt style={{ color: '#165DFF' }} />,
      color: '#e8f3ff',
    },
    {
      title: t('kpis.churnRate'),
      value: Number(kpis.churn_rate || 0),
      suffix: '%',
      precision: 1,
      icon: <IconArrowFall style={{ color: '#f53f3f' }} />,
      color: '#ffece8',
    },
    {
      title: t('kpis.disputeRate'),
      value: Number(kpis.dispute_rate || 0),
      suffix: '%',
      precision: 2,
      icon: <IconExclamationCircle style={{ color: '#ff7d00' }} />,
      color: '#fff7e8',
    },
    {
      title: t('kpis.avgExchangeRate'),
      value: Number(kpis.avg_exchange_rate || 0),
      precision: 2,
      icon: <IconSwap style={{ color: '#722ed1' }} />,
      color: '#f5e8ff',
    },
    {
      title: t('kpis.outstanding'),
      value: Number(kpis.outstanding_usd || 0),
      prefix: '$',
      precision: 2,
      icon: <IconExclamationCircle style={{ color: '#f53f3f' }} />,
      color: '#ffece8',
    },
    {
      title: t('kpis.activeSubscriptions'),
      value: Number(kpis.active_subscriptions || 0),
      precision: 0,
      icon: <IconArrowRise style={{ color: '#00b42a' }} />,
      color: '#e8ffea',
    },
    {
      title: t('kpis.totalStudents'),
      value: Number(kpis.total_students || 0),
      precision: 0,
      icon: <IconUserGroup style={{ color: '#165DFF' }} />,
      color: '#e8f3ff',
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {cards.map((card, i) => (
        <Col key={i} xs={24} sm={12} md={8} lg={6}>
          <Card
            style={{ borderLeft: `3px solid ${card.icon.props.style.color}` }}
            bodyStyle={{ padding: '16px 20px' }}
          >
            <Statistic
              title={
                <Space size="mini">
                  {card.icon}
                  <span>{card.title}</span>
                </Space>
              }
              value={card.value}
              prefix={card.prefix}
              suffix={card.suffix}
              precision={card.precision}
              styleValue={{ fontSize: 24 }}
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default KpiCards;
